/**
 * <header-localization>
 * Menu déroulant de langue (et, en option, de pays) dans l'en-tête.
 * Le clic sur une option met à jour le champ caché du formulaire « localization »
 * puis envoie le formulaire : la page est rechargée dans la langue choisie.
 */
if (!customElements.get('header-localization')) {
  class HeaderLocalization extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.header-localization__button');
      this.panel = this.querySelector('.header-localization__panel');
      this.form = this.querySelector('form');
      if (!this.button || !this.panel || !this.form) return;

      this.onButtonClick = event => {
        event.stopPropagation();
        this.isOpen ? this.close() : this.open();
      };
      this.onPanelClick = event => {
        const option = event.target.closest('[data-option-type]');
        if (option) this.select(option);
      };
      this.onDocumentClick = event => {
        if (this.isOpen && !this.contains(event.target)) this.close();
      };
      this.onKeydown = event => {
        if (event.key === 'Escape' && this.isOpen) {
          this.close();
          this.button.focus();
        }
      };
      this.onFocusOut = event => {
        if (this.isOpen && event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      };

      this.button.addEventListener('click', this.onButtonClick);
      this.panel.addEventListener('click', this.onPanelClick);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    get isOpen() {
      return this.hasAttribute('open');
    }

    open() {
      // un seul menu ouvert à la fois
      document.querySelectorAll('header-localization[open]').forEach(other => {
        if (other !== this) other.close();
      });
      this.setAttribute('open', '');
      this.panel.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.removeAttribute('open');
      this.panel.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
    }

    select(option) {
      const input = this.form.querySelector('input[name="' + option.dataset.optionType + '_code"]');
      if (!input) return;
      if (input.value === option.dataset.value) {
        this.close();
        return;
      }
      input.value = option.dataset.value;
      this.form.submit();
    }
  }

  customElements.define('header-localization', HeaderLocalization);
}
